export type IBuildNameProps = { name: string; basePath: BasePath };

// export const getDynamicLoadProps = (props: IBuildNameProps) => {
//   const errorBoundary = props.basePath === BasePath.LAYOUT ? false : true;
//   const { name, basePath } = componentNameRedirect({
//     name: normaliseDynamicComponentName(props.name),
//     basePath: props.basePath,
//   });
//   return { errorBoundary, name, basePath };
// };

export enum BasePath {
  /** Default modules folder includes opinionated modules */
  MODULES = 'modules',
  LAYOUT = 'layouts',
}

/** Converts Module Name from json payload to name for lookup */
export const normaliseDynamicComponentName = (name: string, helpText = ''): string | undefined => {
  try {
    const normalisedName = name
      // Remove version. Its not used
      .replace('/1', '')
      .replace(/^home$/, 'national')
      // Add dashes on word boundaries. ex "videoSummary" becomes "video-Summary". Not sure if this is still needed.
      .replace(/([a-z])([A-Z])/g, (_, smallLetter, bigLetter) => `${smallLetter}-${bigLetter}`)
      .toLowerCase();
    return normalisedName;
  } catch {
    console.log(`Component Name ${name}: cannot be parsed ${helpText}`);
    return '';
  }
};
